module.exports = __webpack_public_path__ + "static/media/invitation-verified.0de2fa2d.png";